import React from 'react'
import PropTypes from 'prop-types'

const iconMapping = [...Array(9)]
  .map((_v, i) => ({
    [`GHS0${i + 1}`]: `https://d2ezsk340a82m1.cloudfront.net/logo/GHS0${i + 1}.svg`
  }))
  .reduce((acc, curr) => ({ ...acc, ...curr }), {})

const HazardousIcons = ({ hazardInfo }) => {
  if (!hazardInfo?.iconCodes?.length) return null

  return (
    <div className='mxd-hazardous-icons gap-half flex'>
      {hazardInfo.iconCodes.map(code => (
        <img key={code} src={iconMapping[code]} alt={code} />
      ))}
    </div>
  )
}

HazardousIcons.propTypes = {
  hazardInfo: PropTypes.shape({
    iconCodes: PropTypes.array
  }).isRequired
}
export default HazardousIcons
